"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRatingAndReviewDialog = exports.ratingAndReviewDialogContext = exports.defaultRatingAndReviewDialogContextValues = exports.RatingAndReviewDialogProvider = void 0;
var _react = require("react");
const defaultRatingAndReviewDialogContextValues = exports.defaultRatingAndReviewDialogContextValues = {
  open: false,
  orderId: undefined,
  productCode: undefined,
  reviewId: undefined,
  onClose: () => undefined
};
const ratingAndReviewDialogContext = exports.ratingAndReviewDialogContext = /*#__PURE__*/(0, _react.createContext)(defaultRatingAndReviewDialogContextValues);
const RatingAndReviewDialogProvider = exports.RatingAndReviewDialogProvider = ratingAndReviewDialogContext.Provider;
const useRatingAndReviewDialog = () => (0, _react.useContext)(ratingAndReviewDialogContext);
exports.useRatingAndReviewDialog = useRatingAndReviewDialog;
